import axios from 'axios';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  let token = null;
  try { token = localStorage.getItem('ouistupastu_token') || sessionStorage.getItem('ouistupastu_token'); } catch {}
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Response interceptor:
//   1) Normalise Pydantic v2 422 arrays into strings (React-safe).
//   2) Swallow any legacy 402 "quiz limit"-style responses so no banner leaks
//      from a stale server build during the demo. Returns a synthetic 200
//      shape that quiz components already know how to handle.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const d = err?.response?.data?.detail;
    if (status === 402 && typeof d === 'string' && /quiz|limit|free tier|per day/i.test(d)) {
      return Promise.resolve({ data: { ok: true, unlimited: true }, status: 200, headers: {}, config: err.config });
    }
    if (Array.isArray(d)) {
      err.response.data.detail = d.map((e) => e?.msg || (typeof e === 'string' ? e : JSON.stringify(e))).join(', ');
    } else if (d && typeof d === 'object') {
      err.response.data.detail = d.msg || JSON.stringify(d);
    }
    return Promise.reject(err);
  },
);

export default api;
